import {Module} from 'vuex';
import {addAreaRoomInfo, getSysUserListFetch, getEntryReport, removeAreaRoomInfo, reportComplete, sendReportPosition, setReportConfigIds, setReportFloorInfo, uploadDeSignImg} from "@/js/hvac/mapping";
import {Dialog} from "vant";


/**
 * 竣工评论数据模块
 * @type {Module}
 */
export const entry = {
    namespaced: true,
    state: {
        //上传设计图片的列表
        uploadImageList: [],
        // 当前签单手信息
        objSignHandInfo: {},
        // 上门勘察基本信息
        arrBasicInfoEntry: [
            {
                // 标题
                name: '房屋状态',
                // 是否必须
                require: true,
                // 选项值
                values: [
                    {
                        key: '1',
                        value: '毛坯',
                    },
                    {
                        key: '2',
                        value: '已装修',
                    }
                ],
                config: true,
                // 选择的值
                selectValueKeys: [],
                // 标识
                key: '30',
            },
            {

                name: '勘测人员',
                require: true,
                values: [
                    {
                        key: '1',
                        value: '选择勘测人员',
                    }
                ],
                selectValueKeys: [],
                switchBtn: true,
                key: 'kc',
            },
            {
                name: '保温情况',
                require: true,
                multi: true, // 多选
                values: [
                    {
                        key: 'warm_keep',
                        value: '外墙保温',
                    },
                    {
                        key: 'warm_length',
                        value: '双层隔热窗',
                    }
                ],
                selectValueKeys: [],
                key: 'bl',
            },
            {
                name: '水压大小',
                require: true,
                config: true,
                values: [
                    {
                        key: '1',
                        value: '大于1bar',
                    },
                    {
                        key: '2',
                        value: '小于1bar',
                    }
                ],
                selectValueKeys: [],
                key: '42',
            },
            {
                name: '燃气表配置',
                require: true,
                config: true,
                values: [
                    {
                        key: '1',
                        value: '2.5',
                    },
                    {
                        key: '2',
                        value: '4.0',
                    },
                    {
                        key: '3',
                        value: '10',
                    }
                ],
                selectValueKeys: [],
                key: '41',
            }
        ],
        // 房屋勘测详情渲染
        arrSelectProspect: [
            {
                name: '房型',
                key: '1',
                value: '',
            },
            {
                name: '楼层/区域编辑',
                key: '2',
                value: '',
            },
            {
                name: '层高',
                key: '3',
                input: true,
                value: '',
            }
        ],
        // 房屋类型选择数组
        arrRoomTypeSelectList: [
            {
                name: '平层',
                key: '48',
                minVal: 1,
                maxVal: 1,
                // select
            },
            {
                name: '复式',
                key: '49',
                minVal: -2,
                maxVal: 4,
            },
            {
                name: '别墅',
                key: '50',
                minVal: -2,
                maxVal: 5,
            }
        ],
        // 总楼层数据列表
        arrRoomAreaList: [
            // {
            //     name: '一层',
            //     key: '1',
            //     select: true,
            //     rooms: [
            //         {
            //             name: '主卧室',  // 区域名
            //             area: 22, // 面积
            //             direction: '南', // 朝向
            //             level: 3, // 层高
            //             FP: true, // 风盘
            //             DN: true, // 地暖
            //             SLP: false, // 散热片
            //             NF: true, // 新风
            //             pictureList: [],// 图片
            //             nameKey: '1', // 房间key
            //         },
            //     ],
            //     // 总面积数据
            //     floorArea: [
            //         // {type: "1", name: "风盘", num: "0"}
            //     ],
            // },
        ],
        // 表格栏数组，注意key要和总楼层数据的key匹配
        arrTableColumnList: [
            {
                key: 'name',
                name: '区域'
            },
            {
                key: 'area',
                name: '面积'
            },
            {
                key: 'direction',
                name: '朝向'
            },
            {
                key: 'level',
                name: '层高'
            },
            {
                key: 'FP',
                name: '风盘'
            },
            {
                key: 'DN',
                name: '地暖'
            },
            {
                key: 'SLP',
                name: '散热片'
            },
            {
                key: 'NF',
                name: '新风'
            }
        ],
        // 房间总面积
        arrFloorAreaList: [
            {type: "1", name: "空调", num: "0"},
            {type: "2", name: "地暖", num: "0"},
            {type: "4", name: "新风", num: "0"}
        ],
        // 楼层编辑可添加楼层数组
        arrFloorEditAddList: [
            {
                name: '地面楼层',
                key: '1',
                children: [
                    {
                        name: '一层',
                        key: '1',
                        // select
                    },
                    {
                        name: '二层',
                        key: '2'
                    },
                    {
                        name: '三层',
                        key: '3'
                    },
                    {
                        name: '四层',
                        key: '4'
                    },
                    {
                        name: '五层',
                        key: '5'
                    }
                ]
            },
            {
                name: '地下室',
                key: '2',
                children: [
                    {
                        name: '地下室一层',
                        key: '-1'
                    },
                    {
                        name: '地下室二层',
                        key: '-2'
                    },
                ]
            }
        ],
        // 添加区域展示内容数组
        arrAddAreaShowList: [
            {
                title: '室',
                children: [
                    {
                        name: '主卧室',
                        nameKey: '1',
                    },
                    {
                        name: '次卧室',
                        nameKey: '2',
                    },
                    {
                        name: '客房',
                        nameKey: '3',
                    },
                    {
                        name: '老人房',
                        nameKey: '4',
                    },
                    {
                        name: '儿童房',
                        nameKey: '5',
                    },
                    {
                        name: '书房',
                        nameKey: '6',
                    },
                    {
                        name: '健身房',
                        nameKey: '7',
                    },
                    {
                        name: '保姆房',
                        nameKey: '8',
                    },
                    {
                        name: '棋牌室',
                        nameKey: '9',
                    },
                    {
                        name: '影音室',
                        nameKey: '10',
                    },
                    {
                        name: '衣帽间',
                        nameKey: '11',
                    },
                    {
                        name: '茶室',
                        nameKey: '12',
                    }

                ],
                titleKey: 'num_bed',
            },
            {
                title: '厅',
                children: [
                    {
                        name: '客厅',
                        nameKey: '1',
                    },
                    {
                        name: '餐厅',
                        nameKey: '2',
                    },
                    {
                        name: '起居室',
                        nameKey: '3',
                    },
                    {
                        name: '门厅',
                        nameKey: '4',
                    }
                ],
                titleKey: 'num_hall',
            },
            {
                title: '厨',
                children: [
                    {
                        name: '厨房',
                        nameKey: '1',
                    },
                    {
                        name: '中厨',
                        nameKey: '2',
                    },
                    {
                        name: '西厨',
                        nameKey: '3',
                    },
                    {
                        name: '酒吧',
                        nameKey: '4',
                    }
                ],
                titleKey: 'num_kitchen',
            },
            {
                title: '卫',
                children: [
                    {
                        name: '卫1',
                        nameKey: '1',
                    },
                    {
                        name: '卫2',
                        nameKey: '2',
                    }
                ],
                titleKey: 'num_toilet',
            },
            {
                title: '其他',
                children: [
                    {
                        name: '酒窖',
                        nameKey: '1',
                    }
                ],
                titleKey: 'num_veranda',
            }
        ],
        // 当前正在添加的区域 ,添加区域展示内容数组 元素
        objActiveAreaAdd: null,
        // 添加区域标签添加内容
        objAddAreaContent: {
            roomWidth: '', // 长
            roomHeight: '', // 宽
            roomArea: '', // 面积
            floorHeight: '', // 层高
            direction: '', // 朝向
            deviceConfig: {
                configOne: [
                    {
                        name: '风盘',
                        key: 'FP',
                        active: false,
                        type: '1'
                    },
                    {
                        name: '新风',
                        key: 'NF',
                        active: false,
                        type: '4'
                    }
                ],
                configTwo: [
                    {
                        name: '地暖',
                        key: 'DN',
                        active: false,
                        type: '2'
                    },
                    {
                        name: '散热片',
                        key: 'SLP',
                        active: false,
                        type: '3'
                    }
                ],
            },
            pictureList: [], // 图
        },
        // 朝向数据
        arrDirectionList: [
            {
                name: '未知',
                key: '1',
                type: '9',
            },
            {
                name: '北',
                key: '2'
            },
            {
                name: '东',
                key: '3'
            },
            {
                name: '西',
                key: '4'
            }
        ],
        // 配置推荐渲染
        arrRecommended: [
            {
                name: '空调及控制设备定位',
                navTitle: '空调',
                key: '1',
                // edit select
                popupConfig: {
                    // 选择按钮配置
                    choseBtn: [  // 选择按钮渲染
                        {
                            type: 'double',
                            typeKey: '1',
                            children: [
                                {
                                    name: '分体机',
                                    subName: '中央控制器',
                                    btnKey: '1',
                                    select: true,
                                    subProductKey: 'subProductOne',
                                },
                                {
                                    name: '一体机',
                                    subName: '中央控制器',
                                    btnKey: '2',
                                    subProductKey: 'subProductOne',
                                }
                            ],
                            // origin
                        },
                        {
                            type: 'one',
                            typeKey: '2',
                            children: [
                                {
                                    name: '膨胀罐',
                                    btnKey: '1',
                                    inflationInfo: true, // 特殊配置 膨胀罐
                                }
                            ]
                        },
                    ],
                    // 单选设备位置
                    machinePosition: [
                        {
                            doubleKey: '1',
                            children: [
                                {
                                    name: '外机设计位置',
                                    key: '1',
                                    value: '',
                                    imageTitle: '外机位置照片',
                                    imageList: [
                                        // {
                                        //     image: ''
                                        // }
                                    ]
                                },
                                {
                                    name: '内机设计位置',
                                    key: '2',
                                    value: '',
                                    imageTitle: '内机位置照片',
                                    imageList: [
                                        // {
                                        //     image: ''
                                        // }
                                    ]
                                },
                            ],
                        },
                        {
                            doubleKey: '2',
                            children: [
                                {
                                    name: '一体机设计位置',
                                    key: '1',
                                    value: '',
                                    imageTitle: '一体机位置照片',
                                    imageList: [
                                        // {
                                        //     image: ''
                                        // }
                                    ]
                                },

                            ],
                        },

                    ],
                    title: '空调设计、定位',
                    // 附加设备1
                    subProductOne: {
                        subTitle: 'Al-LiNK中央控制器设计、定位',
                        productName: '中央控制器',
                        // 产品列表
                        productList: [
                            {
                                key: '1',
                                select: true,
                                // 位置信息
                                positionValue: '',
                                imageList: [],
                            }
                        ],
                    },
                    // 膨胀罐
                    inflationInfo: {
                        title: '膨胀罐设计定位',
                        positionValue: '',
                        imageList: [],
                    },
                }
            },
            {
                name: '热水、采暖设备定位',
                navTitle: '热水采暖',
                key: '2',
                popupConfig: {
                    choseBtn: [  // 选择按钮渲染
                        {
                            type: 'one',
                            typeKey: '1',
                            children: [
                                {
                                    name: '热水循环',
                                    btnKey: '1',
                                }
                            ]
                        },
                        {
                            type: 'double',
                            typeKey: '2',
                            children: [
                                {
                                    name: '直供',
                                    subName: '分集水器',
                                    btnKey: '1',
                                    select: true,
                                    subProductKey: 'subProductOne',
                                },
                                {
                                    name: '水箱',
                                    subName: '分集水器',
                                    btnKey: '2',
                                    subProductKey: 'subProductOne',
                                }
                            ]
                        },
                    ],
                    machinePosition: [

                        {
                            doubleKey: '1',
                            children: [
                                {
                                    name: '壁挂炉设计位置',
                                    key: '1',
                                    value: '',
                                    imageTitle: '壁挂炉位置照片',
                                    imageList: [
                                        // {
                                        //     image: ''
                                        // }
                                    ]
                                },

                            ]
                        },
                        {
                            doubleKey: '2',
                            children: [
                                {
                                    name: '壁挂炉设计位置',
                                    key: '1',
                                    value: '',
                                    imageTitle: '壁挂炉位置照片',
                                    imageList: [
                                        // {
                                        //     image: ''
                                        // }
                                    ]
                                },
                                {
                                    name: '水箱设计位置',
                                    key: '2',
                                    value: '',
                                    imageTitle: '水箱位置照片',
                                    imageList: [
                                        // {
                                        //     image: ''
                                        // }
                                    ]
                                }
                            ],
                        },
                    ],
                    title: '采暖&热水设计、定位',
                    // 附加设备1
                    subProductOne: {
                        subTitle: '分集水器设计、定位',
                        productName: '分集水器',
                        productList: [
                            {
                                key: '1',
                                select: true,
                                positionValue: '',
                                imageList: [],
                            }
                        ],
                    },
                }
            },
            {
                name: '新风系统设备定位',
                navTitle: '风系统',
                key: '3',
                popupConfig: {
                    choseBtn: [  // 选择按钮渲染
                        {
                            type: 'one',
                            typeKey: '1',
                            mini: true,
                            children: [
                                {
                                    name: '吊顶后层高',
                                    btnKey: '1',
                                    input: true,
                                    value: '',
                                },
                                {
                                    name: '除湿',
                                    btnKey: '2',
                                }
                            ]
                        },
                        {
                            type: 'double',
                            typeKey: '2',
                            children: [
                                {
                                    name: '中央新风',
                                    btnKey: '1',
                                    select: true,
                                },
                                {
                                    name: '壁挂新风',
                                    btnKey: '2',
                                }
                            ]
                        },
                    ],
                    machinePosition: [

                        {
                            doubleKey: '1',
                            children: [
                                {
                                    name: '新风主机设计位置',
                                    key: '1',
                                    value: '',
                                    imageTitle: '新风主机位置照片',
                                    imageList: [
                                        // {
                                        //     image: ''
                                        // }
                                    ]
                                },

                            ]
                        },
                        {
                            doubleKey: '2',
                            children: [
                                {
                                    name: '新风主机设计位置',
                                    key: '1',
                                    value: '',
                                    imageTitle: '新风主机位置照片',
                                    imageList: [
                                        // {
                                        //     image: ''
                                        // }
                                    ]
                                },
                                {
                                    name: '进出风口设计位置',
                                    key: '2',
                                    value: '',
                                    imageTitle: '进出风口位置照片',
                                    imageList: [
                                        // {
                                        //     image: ''
                                        // }
                                    ]
                                }
                            ],
                        },
                    ],
                    title: '风系统设计、定位',
                }
            },
            {
                name: '水处理设备定位',
                navTitle: '水处理',
                needChose: true,
                key: '4',
                popupConfig: {
                    choseBtn: [  // 选择按钮渲染
                        {
                            type: 'double',
                            typeKey: '1',
                            children: [
                                {
                                    name: '前置',
                                    btnKey: '1',
                                    select: true,
                                    subProductKey: 'subProductOne',
                                },
                                {
                                    name: '中央净',
                                    btnKey: '2',
                                    subProductKey: 'subProductTwo',
                                },
                                {
                                    name: '中央软',
                                    btnKey: '3',
                                    subProductKey: 'subProductThree',
                                }
                            ]
                        }
                    ],
                    title: '水处理设备配置',
                    // 附加设备1
                    subProductOne: {
                        subTitle: '分集水器设计、定位',
                        productName: '前置',
                        productList: [
                            {
                                key: '1',
                                select: true,
                                positionValue: '',
                                imageList: [],
                            }
                        ],
                    },
                    // 附加设备2
                    subProductTwo: {
                        subTitle: '中央净设计、定位',
                        productName: '中央净',
                        productList: [
                            {
                                key: '1',
                                select: true,
                                positionValue: '',
                                imageList: [],
                            }
                        ],
                    },
                    // 附加设备3
                    subProductThree: {
                        subTitle: '中央软设计、定位',
                        productName: '中央软',
                        productList: [
                            {
                                key: '1',
                                select: true,
                                positionValue: '',
                                imageList: [],
                            }
                        ],
                    },
                }
            },
            {
                name: 'Al-LiNK标品设备定位',
                navTitle: '标品',
                needChose: true,
                key: '5',
                popupConfig: {
                    choseBtn: [  // 选择按钮渲染
                        {
                            type: 'double',
                            typeKey: '1',
                            children: [
                                {
                                    name: '油烟机',
                                    btnKey: '1',
                                    select: true,
                                    subProductKey: 'subProductOne',
                                },
                                {
                                    name: '末端净水机',
                                    btnKey: '2',
                                    subProductKey: 'subProductTwo',
                                },
                            ]
                        }
                    ],
                    title: '标品设备配置',
                    // 附加设备1
                    subProductOne: {
                        subTitle: '油烟机设计、定位',
                        productName: '前置',
                        productList: [
                            {
                                key: '1',
                                select: true,
                                positionValue: '',
                                imageList: [],
                            }
                        ],
                    },
                    // 附加设备2
                    subProductTwo: {
                        subTitle: '末端净水机设计、定位',
                        productName: '末端净水器',
                        productList: [
                            {
                                key: '1',
                                select: true,
                                positionValue: '',
                                imageList: [],
                            }
                        ],
                    },
                }

            }
        ],
        // 报告是否可编辑
        bReportIsEdit: true,
        // 报告的基本信息
        objReportInfo: {},
        // 页面显示
        pageRender: false,
    },
    mutations: {
        // 保存签单手信息
        SAVE_SIGN_HAND_INFO(state, typeAction) {
            state.objSignHandInfo = typeAction.info;
        },
        // 改变房屋勘测详情渲染
        CHANGE_SELECT_PROSPECT(state, typeAction) {
            state.arrSelectProspect = typeAction.list;
        },
        // 保存报告编辑状态和基本信息
        SAVE_REPORT_EDIT_STATUS(state, typeAction) {
            state.bReportIsEdit = !!typeAction.edit;
            state.objReportInfo = typeAction.info;
        },
        // 改变页面是否渲染
        CHANGE_PAGE_RENDER(state, typeAction) {
            state.pageRender = typeAction.visible;
        },
        // 保存房间总面积
        SAVE_FLOOR_AREA_LIST(state, typeAction) {
            state.arrFloorAreaList = typeAction.list;
        },
        // 上门勘察基本信息改变
        CHANGE_BASIC_INFO_ENTRY(state, typeAction) {
            state.arrBasicInfoEntry = typeAction.list;
        },
        // 总楼层数据列表改变
        CHANGE_ROOM_AREA_LIST(state, typeAction) {
            state.arrRoomAreaList = typeAction.list;
        },
        // 改变楼层编辑可添加楼层选择项
        CHANGE_FLOOR_EDIT_ADD_LIST(state, typeAction) {
            state.arrFloorEditAddList = typeAction.list;
        },
        // 改变楼层编辑可添加楼层长度
        CHANGE_FLOOR_EDIT_ADD_LENGTH(state, typeAction) {
            const {info: {maxVal, minVal}} = typeAction;
            const activeFloorKeys = state.arrRoomAreaList.map(i => i.key);
            state.arrFloorEditAddList = state.arrFloorEditAddList.map(floor => {
                // 目前最高支持五；
                const str = ['一', '二', '三', '四', '五'];
                switch (floor.key) {
                    // 地面楼层
                    case '1':
                        floor.children = [];
                        for (let i = 1; i <= maxVal; i++) {
                            floor.children.push({name: `${str[i - 1]}层`, key: i.toString(), select: activeFloorKeys.includes(i.toString())});
                        }
                        break;
                    // 地下室
                    case '2':
                        floor.children = [];
                        for (let i = -1; i >= minVal; i--) {
                            floor.children.push({name: `地下室${str[Math.abs(i) - 1]}层`, key: i.toString(), select: activeFloorKeys.includes(i.toString())});
                        }
                        break;
                }
                return floor;
            })
        },
        // 保存正在添加的区域
        SAVE_ACTIVE_AREA(state, typeAction) {
            state.objActiveAreaAdd = typeAction.info;
        },
        // 改变添加区域标签添加内容
        CHANGE_ADD_AREA_CONTENT(state, typeAction) {
            const {key, value, info} = typeAction;
            if (info) {
                state.objAddAreaContent = info;
            } else {
                state.objAddAreaContent[key] = value;
            }
        },
        // 改变配置推荐渲染数组
        CHANGE_RECOMMENDED_LIST(state, typeAction) {
            state.arrRecommended = typeAction.list;
        },
        // 保存添加区域展示内容数组
        SAVE_ADD_AREA_SHOW_LIST(state, typeAction) {
            state.arrAddAreaShowList = typeAction.list;
        },
        // 保存朝向数据
        SAVE_DIRECTION_LIST(state, typeAction) {
            state.arrDirectionList = typeAction.list;
        },
        // 保存房屋类型选择数组
        SAVE_ROOM_TYPE_SELECT_LIST(state, typeAction) {
            state.arrRoomTypeSelectList = typeAction.list;
        },
        // 保存图片列表
        SAVE_UPLOAD_IMAGE_LIST(state, typeAction) {
            state.uploadImageList = typeAction.list;
        },
    },
    actions: {


        /**
         * 获取勘察报告
         */
        async getEntryReportIndex({commit, state}, typePayload) {
            const {accountId} = typePayload;
            const {data: {result}} = await getEntryReport({accountid: accountId}).catch(err => {
                commit({type: 'CHANGE_PAGE_RENDER', visible: false})
                return err;
            });

            if (!result) return;


            const {infos = {}, tags, room, direction, equipments} = result;
            // 判断是否可编辑
            commit({type: 'SAVE_REPORT_EDIT_STATUS', edit: Number.parseInt(infos?.state) === 0, info: infos});
            // 填充朝向数据
            commit({type: 'SAVE_DIRECTION_LIST', list: direction});
            // 填充报告附件
            commit({type: 'SAVE_UPLOAD_IMAGE_LIST', list: infos?.attach ?? []});

            // 填充勘察基本信息
            ;(() => {
                const {
                    // 选中的配置信息
                    config_ids = [],
                    // 外墙保温 0无 1有
                    warm_keep,
                    // 窗户隔热 1单 2双
                    warm_length,
                    // 签单手信息
                    user_sign = {},
                } = infos;

                const list = state.arrBasicInfoEntry.map(i => {
                    // 目标元素
                    const target = tags?.find(tag => tag.id === i.key);
                    // 有的话取接口的配置信息
                    if (target) {
                        const {is_require, items} = target;
                        i.values = items.map(item => {
                            return {...item, key: item.id, value: item.name}
                        });
                        // 查找选择项
                        i.selectValueKeys = [i.values.find(i => config_ids.includes(i.id))?.key]

                        return {
                            ...i, ...target,
                            require: !!Number.parseInt(is_require),
                        }
                    }
                    // 保温情况 key = bl
                    if (i.key === 'bl') {
                        // 判断是否外墙保温
                        Number.parseInt(warm_keep) === 1 && i.selectValueKeys.push('warm_keep');
                        // 判断是否双层隔热窗
                        Number.parseInt(warm_length) === 2 && i.selectValueKeys.push('warm_length');
                    }
                    // 勘察人员 key = kc
                    if (i.key === 'kc') {
                        // 填充勘察人员
                        user_sign.fullname && (i.values[0].value = user_sign.fullname)
                    }

                    return i;
                });
                commit({type: 'CHANGE_BASIC_INFO_ENTRY', list});
            })();

            // 填充添加区域展示内容数组
            ;(() => {
                const list = state.arrAddAreaShowList.map(i => {
                    i.children = room.filter(r => r.key === i.titleKey).map(roomItem => {
                        const {id: nameKey} = roomItem;
                        return {...roomItem, nameKey}
                    });
                    return i;
                });
                commit({type: 'SAVE_ADD_AREA_SHOW_LIST', list});
            })();

            // 楼层默认层高填充
            ;(() => {
                const {floor} = infos;
                const list = state.arrSelectProspect.map(i => {
                    if (i.input) {
                        // i.value = floor ?? ''
                        i.value = Number.parseFloat(floor) + 'm' || '';
                    }
                    return i;
                });

                commit({type: 'CHANGE_SELECT_PROSPECT', list});
            })();

            // 填充房屋类型选择数组
            ;(() => {
                const {
                    // 选中的配置信息
                    config_ids = []
                } = infos;
                // 房屋类型数组的id===34固定值
                const target = tags?.find(i => i.id === '34')?.items ?? [];

                const list = target.map(i => {
                    return {
                        ...i,
                        key: i.id,
                        minVal: Number.parseInt(i.min_val),
                        maxVal: Number.parseInt(i.max_val),
                        // 判断选择的房型
                        select: config_ids.includes(i.id),
                    }
                });

                commit({type: 'SAVE_ROOM_TYPE_SELECT_LIST', list});

            })();

            // 填充地暖风盘新风散热片配置
            ;(() => {
                const deviceConfig = {};
                Object.keys(state.objAddAreaContent.deviceConfig).forEach(key => {
                    deviceConfig[key] = state.objAddAreaContent.deviceConfig[key].map(item => {
                        const target = equipments.find(eq => eq.type === item.type);
                        const hasActive = equipments.filter(i => i.type === '2' || i.type === '3').some(i => i.active);
                        if (key === 'configTwo' && !hasActive) {
                            target.type === '2' && (target.active = true);
                        }
                        return {...item, ...target}
                    });
                });

                commit({type: 'CHANGE_ADD_AREA_CONTENT', key: 'deviceConfig', value: deviceConfig});
            })();

            // 填充总楼层数据列表
            ;(() => {
                const {floors} = infos;
                const resultList = [];

                // 如果有长度填充；
                if (floors.length) {
                    // 枚举属性
                    const emuEq = {
                        '1': 'FP',
                        '2': 'DN',
                        '3': 'SLP',
                        '4': 'NF',
                    };
                    floors.forEach(floor => {
                        const target = JSON.parse(JSON.stringify(state.arrFloorEditAddList.map(i => i.children).flat(Infinity).find(i => i.key === floor.room) ?? '{}'));
                        // 房间信息整理
                        target.rooms = floor.rooms.map(item => {
                            const child = {
                                ...item,
                                area: Number.parseInt(item.area),
                                directionId: item.direction,
                                direction: item.direction_name,
                                level: Number.parseInt(item.floor),
                                nameKey: item.id,
                                pictureList: item.attach,
                            };
                            // 附加散热相关信息
                            item.equipments.forEach(eq => {
                                child[emuEq[eq.type]] = eq.num !== '0';
                            });

                            return child;
                        });

                        // 楼层面积信息整理
                        target.floorArea = floor.area;


                        resultList.push(target);


                    });
                    // 排个序
                    resultList.sort((a, b) => {
                        if (b.key < 0) {
                            return +a.key > +b.key ? -1 : 1
                        } else {
                            return +a.key > +b.key ? 1 : -1
                        }
                    });
                }

                // 总面积
                const list = state.arrFloorAreaList.map(area => {
                    area.num = resultList.map(i => i.floorArea).flat(Infinity).filter(i => i.type === area.type).reduce((pre, item) => pre + Number.parseInt(item.num), 0);
                    return area;
                });
                commit({type: 'SAVE_FLOOR_AREA_LIST', list});

                // 提交楼层数据
                commit({
                    type: 'CHANGE_ROOM_AREA_LIST', list: resultList.map((item, index) => {
                        item.select = index === 0;
                        return item;
                    })
                });

            })();

            // 填充设备定位信息
            ;(() => {
                const {position} = infos;

                if (position?.length) {

                    const list = state.arrRecommended.map(config => {
                        const {items, type} = position.find(po => po.type === config.key);
                        // 展开的设备列表（ all sub）
                        const allItems = [];
                        items.forEach(i => {
                            allItems.push(i);
                            if (i.sub.length) allItems.push(...i.sub);
                        });


                        // 按钮配置
                        config.popupConfig.choseBtn = config.popupConfig.choseBtn.map(chose => {

                            // 拿到父级id
                            chose.children = chose.children.map((btn) => {
                                const target = allItems?.find(i => i.name === btn.name);

                                // 5是按钮类型
                                const hasSelect = target?.show_type === '5' ? !!Number.parseInt(target.prospect_position_id) : target?.positions.some(i => !!Number.parseInt(i.prospect_position_id));

                                hasSelect && (config.edit = true);
                                return {
                                    ...btn,
                                    parentId: target?.id,
                                    select: hasSelect,
                                    value: target?.position_name,
                                }
                            });
                            return chose;
                        });

                        // 整理默认选中的按钮
                        config.popupConfig.choseBtn = config.popupConfig.choseBtn.map(chose => {
                            if (chose.type === 'double' && chose.children.every(i => !i.select)) {
                                chose.children[0].select = true;
                            }
                            return chose;
                        });

                        // 膨胀罐
                        const inflationInfo = allItems?.find(i => i.name === '膨胀罐');
                        if (inflationInfo) {
                            const {id, positions: [{id: subId, position_name, attach}]} = inflationInfo;
                            config.popupConfig.inflationInfo = {
                                ...config.popupConfig.inflationInfo,
                                parentId: id,
                                positionValue: position_name,
                                subId,
                                imageList: attach
                            }
                        }

                        // 单选设备
                        config.popupConfig.machinePosition = config.popupConfig.machinePosition?.map(mach => {
                            // 单选设备按钮配置
                            const parent = config.popupConfig.choseBtn.find(i => i.type === 'double')?.children.find(i => i.btnKey === mach.doubleKey);

                            mach.children = mach.children.map(product => {
                                // 父级
                                const targetItem = allItems.find(i => i.name === parent.name);
                                if (targetItem) {
                                    const target = targetItem.positions.find(i => i.name === product.name);
                                    product.parentId = targetItem.id;
                                    product.subId = target?.id;
                                    product.imageList = target?.attach;
                                    product.value = target?.position_name;
                                }
                                return product;
                            });

                            return mach;
                        });

                        const localSubProductList = config.popupConfig.choseBtn.find(i => i.type === 'double')?.children;
                        // 附加设备  类型是2的为附加设备
                        allItems.filter(i => i.show_type === '2').forEach(productItem => {
                            const target = localSubProductList.find(i => i.name === productItem.name_sub || i.subName === productItem.name_sub);
                            if (target) {
                                const keyName = target.subProductKey;
                                // 整理附加设备
                                config.popupConfig[keyName].productList = productItem.positions.map((product, index) => {
                                    const {id: subId, position_name, attach} = product;
                                    return {
                                        key: index + 1,
                                        select: index === 0,
                                        parentId: productItem.id,
                                        positionValue: position_name,
                                        subId,
                                        imageList: attach
                                    }
                                });
                            }
                        });


                        return {...config, key: type};
                    });

                    // 默认选中一个
                    const editEr = list.find(c => c.edit)
                    editEr && (editEr.select = true);

                    commit({type: 'CHANGE_RECOMMENDED_LIST', list});

                    commit({type: 'CHANGE_PAGE_RENDER', visible: true})
                }
            })();
        },
        /**
         * 设置房间配置信息
         */
        async setReportConfigInfo({getters, state}) {
            const {ids, bl} = getters.reportConfigIds;
            const data = {
                report_id: state.objReportInfo.id,
                config_ids: [...ids, getters.reportRoomTypeId].reduce((pre, item, index) => `${pre}${item}${index < ids.length ? ',' : ''}`, ''),
                warm_keep: bl.some(i => i === 'warm_keep') ? 1 : 0,
                warm_length: bl.some(i => i === 'warm_length') ? 2 : 1,
                floor: state.arrSelectProspect.find(i => i.input)?.value,
                user_id_prospect: state.objSignHandInfo.systemuserid,
            };
            await setReportConfigIds(data);
        },
        /**
         * 设置房间的楼层信息
         * @param state
         * @param typePayload
         * @returns {Promise<void>}
         */
        async setReportFloor({state, commit}, typePayload) {
            const {list} = typePayload;
            const data = {
                report_id: state.objReportInfo.id, // require, 报告id
                floor: list.reduce((pre, item, index) => `${pre}${item.key}${index < list.length - 1 ? ',' : ''}`, ''),
            }
            await setReportFloorInfo(data).then(() => {
                commit({type: 'CHANGE_ROOM_AREA_LIST', list});
            });
        },
        /**
         * 添加编辑房间
         * @returns {Promise<void>}
         */
        async addEditRoomInfo({state}, typePayload) {
            const {name, id, roomId, floorHeight, roomArea, roomHeight, roomWidth, floorKey, direction, pictureList, deviceConfig: {configOne, configTwo}, editInfo} = typePayload.info;
            const data = {
                id: editInfo ? roomId : 0, // 是否编辑 默认0 否
                report_id: state.objReportInfo.id, // require, 报告id
                room: floorKey, // require, // 楼层id
                name, // 房间名
                room_id: id, // require, //
                long: roomWidth, // 长
                wide: roomHeight, // 宽
                area: roomArea, // 面积
                floor: floorHeight, // 楼高
                direction: state.arrDirectionList.find(i => i.name === direction)?.type ?? '9', // require, 方向
                imgs: pictureList.reduce((pre, item, index) => `${pre}${item.img}${index < pictureList.length - 1 ? ',' : ''}`, '') || undefined, // 图片列表
                equipments: JSON.stringify([...configOne, ...configTwo].map(i => {
                    i.num = i.active ? '1' : '0';
                    return i;
                })), // require, 附件
            }

            const {data: {result}} = await addAreaRoomInfo(data);
            return result;
        },
        /**
         * 移除房间
         * @param _
         * @param typePayload
         * @returns {Promise<void>}
         */
        async removeRoomInfo({commit}, typePayload) {
            const data = {
                id: typePayload.deleteId
            }
            await removeAreaRoomInfo(data).then(() => {
                commit({type: 'CHANGE_ROOM_AREA_LIST', list: typePayload.list});
            });
        },
        /**
         * 提交报告的定位信息
         * @returns {Promise<void>}
         */
        async sendReportPositionFet({commit, state}, typePayload) {
            const {info: _info} = typePayload;
            const info = JSON.parse(JSON.stringify(_info));
            // 目标数组
            const position = [];
            const {choseBtn, machinePosition, inflationInfo} = info.popupConfig;

            choseBtn.forEach(chose => {
                // 拿到选择的按钮配置 children
                const hasSelect = chose.children.filter(c => c.select || c.value);
                if (hasSelect.length && chose.type === 'double') {
                    // 当前选择的多选配置
                    const selectDoubleMachine = machinePosition?.find(mach => mach.doubleKey === hasSelect[0].btnKey).children;
                    selectDoubleMachine?.forEach(product => {
                        const imgList = product.imageList;
                        position.push({
                            position_id: product.parentId, position_item_id: product.subId, position_num: '0',
                            position_name: product.value, imgs: imgList.reduce((pre, item, index) => `${pre}${item.img}${index < imgList.length - 1 ? ',' : ''}`, '')
                        });
                    });
                    // 当前附加设备的配置
                    hasSelect.forEach(({subProductKey}) => {
                        const subProduct = info.popupConfig[subProductKey];
                        subProduct?.productList.forEach(product => {
                            const imgList = product.imageList;
                            position.push({
                                position_id: product.parentId, position_item_id: product.subId, position_num: product.key,
                                position_name: product.positionValue, imgs: imgList.reduce((pre, item, index) => `${pre}${item.img}${index < imgList.length - 1 ? ',' : ''}`, '')
                            });
                        });
                    });


                } else if (hasSelect.length && chose.type === 'one') {

                    hasSelect.forEach(i => {
                        // 是否选择膨胀罐
                        if (i.inflationInfo) {
                            const imgList = inflationInfo.imageList;
                            position.push({
                                position_id: inflationInfo.parentId, position_item_id: inflationInfo.subId, position_num: '0',
                                position_name: inflationInfo.positionValue, imgs: imgList.reduce((pre, item, index) => `${pre}${item.img}${index < imgList.length - 1 ? ',' : ''}`, '')
                            });
                        } else if (i.input) {
                            // 输入框
                            position.push({
                                position_id: i.parentId, position_item_id: '', position_num: '0',
                                position_name: i.value, imgs: ''
                            });
                        } else {
                            // 按钮
                            position.push({
                                position_id: i.parentId, position_item_id: '', position_num: '0',
                                position_name: 1, imgs: ''
                            });
                        }
                    });

                }

            });
            const data = {
                report_id: state.objReportInfo.id, // 报告id
                type: info.key,
                position: JSON.stringify(position),
            }
            await sendReportPosition(data);
        },
        /**
         * 上传报告的设计附件
         * @returns {Promise<void>}
         */
        async uploadReportDesignImage({state}) {
            const list = state.uploadImageList;
            const data = {
                report_id: state.objReportInfo.id,
                imgs: list.reduce((pre, item, index) => `${pre}${item.img}${index < list.length ? ',' : ''}`, '')
            }
            await uploadDeSignImg(data);
        },
        /**
         * 报告确认
         */
        async reportCompleteFet({state}) {
            const action = await Dialog.confirm({message: '报告提交后无法编辑', title: '确定提交？',});

            if (action === 'confirm') {
                const res = await reportComplete({report_id: state.objReportInfo.id}).catch(() => {
                    throw  new Error('信息录入不完整');
                }).then(() => {
                    return {contract_id: state.objReportInfo?.contract_id, id: state.objReportInfo?.id};
                });

                return res;
            }

        },
        async getSysUserInfo({dispatch, commit, rootState}) {
            await dispatch({type: "getSignHandInfo"}, {root: true});
            const sysuserid = rootState.objSignHandInfo.salesid;
            const [info] = await dispatch({type: 'getSysUserList', sysuserid})
            commit({type: 'SAVE_SIGN_HAND_INFO', info})
        },
        /**
         * 获取签单手列表
         * @returns {Promise<void>}
         */
        async getSysUserList(_, payload) {
            const {sysuserid,search} = payload;
            const res = await getSysUserListFetch({sysuserid,search})
            return res.data.result.list;
        },
    },
    getters: {
        /**
         * 报告的基本信息配置ID
         */
        reportConfigIds(state) {
            const lenArr = state.arrBasicInfoEntry.filter(i => i.config);
            const ids = lenArr.map(i => i.selectValueKeys).flat(Infinity).filter(i => ['string', 'number'].includes(typeof i));
            return {
                ids,
                bl: state.arrBasicInfoEntry.find(i => i.key === 'bl').selectValueKeys,
                // 是否可以提交
                canNext: ids.length === lenArr.length
            };
        },
        /**
         * 房间类型id
         * @param state
         * @returns {string}
         */
        reportRoomTypeId(state) {
            const {id, key} = state.arrRoomTypeSelectList.find(i => i.name === state.arrSelectProspect[0].value) ?? {};
            return id ?? key;
        }
    },
}

